import React from 'react';
import styles from './Order.module.css';

const Order = () => {
  const openOrderForm = () => {
    window.open('https://form.jotform.com/212676109824358', '_blank', 'width=650,height=800');
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="order" className={styles.order}>
      <div className="container">
        <div className={styles.orderContent}>
          <h2 className={styles.orderTitle}>Заказать гостиничные чеки</h2>
          <div className={styles.orderText}>
            <p><strong>Вы можете самостоятельно заказать чеки от гостиницы в Челябинске. Для этого есть два способа:</strong></p>
            <div className={styles.methods}>
              <div className={styles.method}>
                <span className={styles.methodIcon} style={{color: '#128000'}}>█</span>
                <span className={styles.methodText}>
                  Свяжитесь с оператором по телефонам, электронной почте или в удобном мессенджере. 
                  Все возможные контакты для связи указаны в соответствующем разделе сайта.
                </span>
              </div>
              <div className={styles.method}>
                <span className={styles.methodIcon} style={{color: '#FF5757'}}>█</span>
                <span className={styles.methodText}>
                  Заполните онлайн заявку ниже, и с вами свяжется наш оператор, что бы согласовать необходимые 
                  даты проживания, стоимость и наличие дополнительных услуг в гостиничном чеке.
                </span>
              </div>
            </div>
          </div>
          <div className={styles.orderButtons}>
            <button className={`btn btn-primary ${styles.orderButton}`} onClick={scrollToContact}>
              <i className="fa fa-phone"></i> КОНТАКТЫ
            </button>
            <button className={`btn btn-secondary ${styles.orderButton}`} onClick={openOrderForm}>
              <i className="fa fa-check-square-o"></i> ЗАКАЗАТЬ ЧЕКИ
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Order;